import type {List} from 'immutable';
import type {ClassroomModelV1} from 'resources/augmented/Classroom/ClassroomModel.v1';
import {mandarkEndpoint} from '@albert-io/json-api-framework/request/builder/legacy';

import masqueradeStore from 'client/generic/Masquerade/Masquerade.store';

/**
 * Every classroom the teacher has, archived included — a classroom absent here has its student
 * assignments dropped on save. 250 is `max_page_size`; `classrooms_v1` rejects `'infinite'`.
 */
export const getClassroomsWithStudents = async (): Promise<List<ClassroomModelV1>> => {
  const query = mandarkEndpoint([
    'teachers_v1',
    masqueradeStore.getUserIdByMasqueradeState() as string,
    'classrooms_v1'
  ])
    .include('students_v2')
    .pageSize(250)
    .sort('name');
  return (await query.getResourcePromise()) as List<ClassroomModelV1>;
};
